import { render, staticRenderFns } from "./DisplayTextField.vue?vue&type=template&id=3519eb9d"
import script from "./DisplayTextField.vue?vue&type=script&lang=js"
export * from "./DisplayTextField.vue?vue&type=script&lang=js"
import style0 from "./DisplayTextField.vue?vue&type=style&index=0&id=3519eb9d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
